//=====================================================
//　コンテンツボックス
//=====================================================

interface IFProps {
    children: any,
    className?: string,
}

export function ContentsBox(props:IFProps){

    let tmpClass = "";
    if (props.className){
        tmpClass = " " + props.className;
    }
    
    return (
        <div className={"contents-box" + tmpClass}>{props.children}</div>
    )

}